import React from 'react'
import QueryToJson from 'Utils/QueryToJson'

export default class PaginationLink extends React.Component {
  constructor(props) {
    super(props)

    this.onClick = this.onClick.bind(this)
  }

  onClick(e) {
    e.preventDefault()

    if (this.props.useHistoryApi && window.history && window.history.replaceState) {
      window.history.replaceState(null, null, e.currentTarget.href)
    }

    return this.props.onPaginationLinkClick(this.props.pageNumber)
  }

  render() {
    const query = QueryToJson(window.location.search.substr(1))
    query.page = this.props.pageNumber

    const href = `${window.location.pathname}?${$.param(query)}`

    return (
      <a href={href} onClick={this.onClick}>
        {this.props.linkText}
      </a>
    )
  }
}
